<template>
    <b-container class="faq" fluid>
        <b-row>
            <b-col class="module">
                <ModuleTitle :caption="faq.title"></ModuleTitle>
            </b-col>
        </b-row>
        <b-row class="list-item">
            <b-col v-for="(item, itemIndex) in faq.items" :key="itemIndex" class="col">
                <b-card :title="item.name">
                    <b-card-text v-for="(desc, textIndex) in item.desc" :key="textIndex"  @click="goToPage(desc.slug)">
                        <a :href="'/faq/' + desc.slug" onclick="return false">
                            {{desc.name}}
                        </a>
                    </b-card-text>
                </b-card>
            </b-col>
        </b-row>
        <b-row class="contact">
            <b-col>
                <div class="title">{{faq.contact.desc | pageTitle}}</div>
                <div class="btn-container">
                    <a :href="faq.contact.btn.to" onclick="return false">
                        <b-button class="btn dark" @click="redirect(faq.contact.btn.to)">{{faq.contact.btn.text}}</b-button>
                    </a>
                </div>
            </b-col>
        </b-row>
    </b-container>
</template>

<script>
    import ModuleTitle from '../components/common/ModuleTitle'

    import {mapState, mapActions} from 'vuex'

    export default {
        name: 'faq',
        components: {
            ModuleTitle,
        },
        computed: {
            ...mapState('faq', {
                faq: ({faq}) => {

                    let items = []

                    if (faq.faq) {
                        items = faq.faq.faq_categories.map(cate => {
                            return {
                                name: cate.name,
                                desc: cate.items.map(item => {
                                    return {
                                        name: item.title,
                                        slug: item.slug,
                                    }
                                })
                            }
                        })
                    }

                    return {
                        title: faq.title,
                        items: items,
                        contact: {
                            desc: faq.faq && faq.faq.need_help_text,
                            btn: {
                                text: faq.faq && faq.faq.contact_us_btn_text,
                                to: faq.faq && faq.faq.contact_us_btn_link,
                            }
                        }
                    }
                },

            })
        },
        methods: {
            ...mapActions('faq', ['getPageInfo']),
            redirect(path) {
                this.$router.push({
                    path,
                })
                document.scrollingElement.scrollTop = 0
            },
            goToPage(slug) {
                this.$router.push({
                    path: '/faq/' + slug
                })
                document.scrollingElement.scrollTop = 0
            }
        },
        created() {
            this.getPageInfo()
        }
    }
</script>

<style lang="less" scoped>
    @import "../assets/style/var";

    .en {
        .faq {
            .card {
                .card-body {
                    .card-title {
                        font-family: Montserrat-Medium, Helvetica, Arial, sans-serif !important;
                    }

                    .card-text {
                        font-size: 13px !important;
                    }
                }
            }
        }

        .btn-container {
            .btn {
                line-height: 1 !important;
            }
        }
    }

    .faq {
        padding: 0 150px;

        .list-item {
            .col {
                &:nth-child(n+5) {
                    margin-top: 100px;
                }
            }
        }

        .module {
            text-align: left;

            /deep/ .title {
                padding-top: 192px !important;
                padding-bottom: 102px !important;
            }
        }

        .card {
            border: none;

            .card-body {
                padding: 0;
                text-align: left;

                .card-title {
                    margin-bottom: 20px;
                    font-size: 20px;
                    line-height: 28px;
                    font-family: NotoSansKR-Medium, Helvetica, Arial, sans-serif !important;
                }

                .card-text {
                    font-size: 14px;
                    line-height: 28px;
                    margin-bottom: 0 !important;
                    transition: color .3s;
                    cursor: pointer;
                    &:hover {
                        color: #666;
                    }
                }
            }
        }

        .contact {
            .title {
                margin: 121px auto 50px auto;
                text-align: center;
                font-size: 18px;
                line-height: 27px;
            }

            .btn-container {
                text-align: center;
                .btn {
                    width: 400px;
                    font-size: 18px;
                    line-height: 45px;
                    padding: 0;
                }
            }
        }
    }
</style>
